const baseUrl = '/dashboard'; // TODO: TBD

export const dashboardRoutes = {
  baseUrl: "".concat(baseUrl)
};